import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";
import NotAuthorized from "./NotAuthorized";

export const ProtectedAdminRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const { t } = useTranslation();
  if (isLoading) {
    // Optional: Show a loading spinner while checking auth state
    return <div>{t('loadingAuthentication')}</div>; 
  }

  const isAdmin = user?.customData?.admin;

  if (!isAuthenticated || !isAdmin) {

    return <NotAuthorized />; 
  }
  return <Outlet />;
};